import { render, staticRenderFns } from "./MailTemplateUpdate.vue?vue&type=template&id=513c25b4&scoped=true&"
import script from "./MailTemplateUpdate.vue?vue&type=script&lang=js&"
export * from "./MailTemplateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513c25b4",
  null
  
)

export default component.exports